<template>
  <AsyncPage :loader="useAccountHomeLoader" :page-component="HomePage" />
</template>

<script setup lang="ts">
import { defineAsyncComponent } from "vue";
import { AsyncPage } from "@saflib/vue/components";
import { useAccountHomeLoader } from "./HomePage.loader.ts";

const HomePage = defineAsyncComponent(() => import("./HomePage.vue"));
</script>
